/* eslint-disable */

import { getCookie } from "tiny-cookie";
import { GetterTree } from "vuex";
import { RootState } from "@/types";
import { UserState } from "@/types/user";

const getters: GetterTree<UserState, RootState> = {
  isAuthorized: state => state.user!.id !== 0,
  accessToken: () => getCookie("access_token") || null,
  refreshToken: () => getCookie("refresh_token") || null,
  isAdmin: state => 0 < state.user!.role && state.user!.role <= 5,
  isUser: state => 5 < state.user!.role && state.user!.role <= 10,
  isCustomer: state => 10 < state.user!.role && state.user!.role <= 15,
  isSubcontractor:state => 15 < state.user!.role && state.user!.role <= 20,
  isVerifed: state => !!state.user!.email_verified_at,
  me: state => state.user
};

export default getters;
